import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MoldovaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15479'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15479)'>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#EB1C43'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#115BCB'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#FFD953'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52465 5.59995H8.57227V8.39995L10.0008 9.33328L11.4294 8.39995V5.59995H10.477L10.0008 4.19995L9.52465 5.59995ZM10.477 6.53328H9.52465V7.93328H10.477V6.53328Z'
					fill='#AF7F59'
				/>
			</g>
		</svg>
	);
};

export default MoldovaFlagIcon;
